import React, { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import BannerSection from "../BannerSection/BannerSection";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const NuestraOperacion = () => {

    useLayoutEffect(() => {
                    window.scrollTo(0, 0)
                });
                const { t } = useTranslation();

    return (
        <section className="nuestra-operacion">
            <BannerSection />

            <div className="container-intro">
                <img src="../../assets/img/logo.webp" alt="YASKIA" title="YASKIA" />
                <article>
                    {t("operacion.intro")}
                </article>
            </div>

            <div className="container-operacion">
                <div className="img-operacion" style ={ {backgroundImage: `url('../assets/img/img-operacion.webp')` } }></div>
                <div className="txt-operacion">
                    <h2>
                        {t("operacion.logistica")}
                    </h2>
                    <article>
                        {t("operacion.logisticatxt")}
                    </article>
                    <h2>
                        {t("operacion.servicios")}
                    </h2>
                    <article>
                        {t("operacion.serviciostxt")}
                    </article>
                </div>
            </div>

            <div className="container-flota">
                <h2>
                    {t("operacion.flota")}
                </h2>
                <article>
                    {t("operacion.flotatxt")}
                </article>
                <Swiper
                    modules={[Autoplay, Pagination, Navigation]}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    navigation
                    loop
                    >
                    <SwiperSlide>
                        <img src="../../assets/img/flota/alborada.webp" alt="Alborada" title="Alborada" />
                        <div className="info-flota">
                            <h3>ALBORADA</h3>
                            <span>{t("operacion.capacidadalborada")}</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src="../../assets/img/flota/barracuda.webp" alt="Barracuda" title="Barracuda" />
                        <div className="info-flota">
                            <h3>BARRACUDA</h3>
                            <span>{t("operacion.capacidadbarracuda")}</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src="../../assets/img/flota/don-omar.webp" alt="Don Omar" title="Don Omar" />
                        <div className="info-flota">
                            <h3>DON OMAR</h3>
                            <span>{t("operacion.capaciddonomar")}</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src="../../assets/img/flota/natanael.webp" alt="Natanael I" title="Natanael I" />
                        <div className="info-flota">
                            <h3>NATANAEL I</h3>
                            <span>{t("operacion.capacidadnatanael")}</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src="../../assets/img/flota/veronica-alejandra.webp" alt="Veróncia Alejandra" title="Veróncia Alejandra" />
                        <div className="info-flota">
                            <h3>VERÓNICA ALEJANDRA</h3>
                            <span>{t("operacion.capacidadalejandra")}</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src="../../assets/img/flota/yaskia.webp" alt="YAKISA" title="YAKISA" />
                        <div className="info-flota">
                            <h3>YAKISA</h3>
                            <span>{t("operacion.capacidadyakisa")}</span>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>

            <div className="container-cierre">
                <article>
                    {t("operacion.cierre1")}
                    <br/><br/>
                    {t("operacion.cierre2")}
                </article>
                <div>
                    <h2>
                        {t("operacion.internacional")}
                    </h2>
                    <article>
                        {t("operacion.internacionaltxt")}
                    </article>                 
                </div>
                <img src="../../assets/img/mapa.webp" alt="YASKIA" title="YASKIA" />
            </div>

        </section>
    );
}

export default NuestraOperacion;
